<template>
  <div v-if="!!targetedPromotionLabel" class="promo-code" data-testId="sbx-pcs-productPromoCode">
    <p class="promo-code__text">
      <VoucherSvg />
      {{ targetedPromotionLabel }}
    </p>
  </div>
</template>

<script lang="js">
import VoucherSvg from '../../../atoms/Icons/voucherSvg.vue';
import { getTargetedPromotionLabel } from '../../../utils/targetedPromotionsUtils';
import { debounce } from '../../../utils';

export default {
  name: 'Voucher',
  components: { VoucherSvg },
  props: {
    product: Object,
  },
  data() {
    return {
      isMobile: true,
      targetedPromotionLabel: null,
      targetedPromotionUpdated: 1,
    };
  },
  methods: {
    getTargetedPromotionLabel,
    updateTargetedPromotionLabel() {
      this.updateIsMobile();
      this.targetedPromotionUpdated++;
    },
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 640;
    },
  },
  mounted() {
    this.updateTargetedPromotionLabel();
    window.addEventListener('resize', () => debounce(this.updateTargetedPromotionLabel, 200));
    window.addEventListener('targeted-promotion:set-storage', this.updateTargetedPromotionLabel);
  },
  watch: {
    targetedPromotionUpdated() {
      this.targetedPromotionLabel = this.getTargetedPromotionLabel(this.product, this.isMobile);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../scss/variables';

.promo-code {
  &__text {
    color: $collection-white;
    background: #7e2182;
    font-family: $brand-font-bold;
    font-size: rem-calc(12);
    line-height: rem-calc(16);
    padding: rem-calc(4);
    margin: 0 0 rem-cacl(8);
    border-radius: rem-calc(4);
    @media #{$mobile-up} {
      padding: rem-calc(6 10);
    }
  }

  svg {
    fill: $collection-white;
    margin-bottom: rem-calc(-3);
    height: rem-calc(13);
  }
}
</style>
